<section *ngIf="job$ | async as job; else skeleton" #globalContainer>
  <span wizHeadTitle>
    {{ job.title }} - {{ job.company.name }}
    {{ getCity(job) ? '- ' + getCity(job) : '' }}
    - WIZBII
  </span>

  <span wizHeadDescription>
    {{ job.contract && job.contract.titleShort ? job.contract.titleShort + ' :' : '' }}
    <ng-container i18n>{{ job.title }} chez {{ job.company.name }}</ng-container>
    <ng-container *ngIf="getCity(job) as city" i18n> à {{ city }}</ng-container
    >.
    <ng-container i18n>Postulez dès maintenant et trouvez d'autres jobs sur WIZBII</ng-container>
  </span>

  <div
    *ngIf="
      showMedia &&
      wizbiiDomain &&
      wizbiiDomain !== 'undefined' &&
      locale === LocaleEnum.fr_FR &&
      (isMobile$ | async) === false
    "
    class="topbar-media"
  >
    <wiz-media [attr.domain]="wizbiiDomain" cookiekey="wizbii_tokens" spot="TopBarAdWizbii"></wiz-media>
  </div>

  <job-fullweight
    class="view-job"
    [model]="job"
    [logged]="false"
    (toggleBookmark)="toggleBookmark(job)"
    (applyButtonHidden)="showFooter = $event"
    @jobEnterLeave
  ></job-fullweight>

  <footer
    *ngIf="showFooter"
    class="job-footer"
    @slideBottom
    [class.job-footer--bottom]="(applyButtonFixed$ | async) === true"
  >
    <a
      class="job-footer__apply-btn"
      [href]="accountUrlSignup"
      appEventTracker
      eventCategory="Job Page"
      eventAction="Click See Job"
      eventLabel="Unlogged Bottom"
      i18n="@@job.apply.unlogged.mobile"
      >Postuler maintenant</a
    >
  </footer>
</section>

<ng-template #skeleton>
  <job-fullweight-skeleton @skeletonEnter></job-fullweight-skeleton>
</ng-template>
